<template>
  <div>
    <!-- Add option -->
    <b-form @submit.prevent="addOption">
      <b-form-group :label="$t('risk.template.option_name')" label-for="option-name">
        <b-form-input
          id="option-name"
          v-model.trim="optionName"
          required
        />
      </b-form-group>

      <!--allow comment flag per option -->
      <b-form-group :label="tAllowComment" label-for="option-allow-comment">
        <b-form-checkbox
          id="option-allow-comment"
          v-model="optionAllowComment"
          switch
        >
          {{ tAllowComment }}
        </b-form-checkbox>
      </b-form-group>

      <b-button type="submit" variant="primary">
        {{ $t('risk.template.add_option') }}
      </b-button>
    </b-form>

    <hr />

    <!-- List -->
    <div v-if="localOptions.length">
      <h5>{{ $t('risk.template.added_options') }}</h5>

      <b-table small :items="localOptions" :fields="fields" responsive>
        <!-- name (read-only) -->
        <template #cell(name)="{ item }">
          <span>{{ item.name }}</span>
        </template>

        <!-- allowComment toggle -->
        <template #cell(allowComment)="{ index }">
          <b-form-checkbox
            v-model="localOptions[index].allowComment"
            switch
            @change="emitUpdate()"
          />
        </template>

        <template #cell(actions)="{ index }">
          <b-button size="sm" variant="danger" @click="removeOption(index)">
            {{ $t('actions.delete') }}
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      optionName: '',
      optionAllowComment: false,
      // Clon local, normilizes old options
      localOptions: this.normalizeOptions(this.data),
      fields: [
        { key: 'name', label: this.$t('risk.template.name') },
        { key: 'allowComment', label: this.$t('custom_forms.allow_comment')},
        { key: 'actions', label: this.$tc('actions.name', 1) },
      ],
    };
  },
  computed: {
    tAllowComment () {
      return this.$t('custom_forms.allow_comment');
    }
  },
  methods: {
    normalizeOptions(arr) {
      const src = Array.isArray(arr) ? arr : [];
      return src.map(o => ({
        name: o?.name ?? '',
        //keeps compat if the flag already exits or its false by default
        allowComment: typeof o?.allowComment === 'boolean' ? o.allowComment : false,
      }));
    },
    emitUpdate() {
      //emits an object array
      this.$emit('update:data', [...this.localOptions]);
    },
    addOption() {
      if (!this.optionName) return;

      this.localOptions.push({
        name: this.optionName,
        allowComment: !!this.optionAllowComment,
      });

      // reset form
      this.optionName = '';
      this.optionAllowComment = false;

      this.emitUpdate();
    },
    removeOption(index) {
      this.localOptions.splice(index, 1);
      this.emitUpdate();
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.localOptions = this.normalizeOptions(newVal);
      },
    },
  },
};
</script>

<style scoped></style>
